import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';
import {map, tap} from 'rxjs/operators';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
  }

  canActivate({data}: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this
      .authService
      .init()
      .pipe(
        map(currentUser => currentUser !== undefined),
        tap(isAuthenticated => {
          if (!isAuthenticated) {
            console.log(
              'Navigation blocked by the authentication guard because session had ' +
              'not been established and current user is not known. Navigating to login.'
            );
            this.router.navigate(['/sessions/login']);
          }
        })
      );
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/services/authentication-guard.service.ts